import SwapVertIcon from "@mui/icons-material/SwapVert";
import { IconButton } from "@mui/material";
import { Form } from "react-bootstrap";
import { useGeneralAppStore } from "../../../../store/generalAppStore";

const HeaderColumn = ({
  setFiltersField,
  setOrder,
  setOrderField,
  field,
  typeInput,
  place,
  reportes,
}) => {
  const { loads } = useGeneralAppStore();

  const loadKeys = ["audits", "acta_detalle"];

  return (
    <>
      <div className="d-flex align-items-center">
        {typeInput == "select" && (
          <>
            <Form.Select
              defaultValue={""}
              disabled={loadKeys.some((key) => loads.includes(key))}
              className="col "
              name={field}
              id={field}
              onChange={(e) => {
                setFiltersField((prevState) => ({
                  ...prevState,
                  [e.target.name]: e.target.value,
                }));
              }}
            >
              {field == "motivo" && (
                <>
                  <option value="" disabled>
                    Motivo
                  </option>
                  <option value="Duplicado">Duplicado</option>
                  <option value="Error de sistema">Error de sistema</option>
                  <option value="No es infracción">No es infracción</option>
                </>
              )}
            </Form.Select>
          </>
        )}
        {(typeInput == "text" || typeInput == "number") && (
          <Form.Control
            disabled={loadKeys.some((key) => loads.includes(key))}
            type={typeInput}
            name={field}
            className="col "
            placeholder={place}
            onChange={(e) => {
              setFiltersField((prevState) => ({
                ...prevState,
                [e.target.name]: e.target.value,
              }));
            }}
          />
        )}

        <IconButton
          disabled={loadKeys.some((key) => loads.includes(key))}
          onClick={() => {
            setOrder((prevState) => {
              if (prevState == "asc") {
                prevState = "des";
              } else {
                prevState = "asc";
              }
              return prevState;
            });
            setOrderField(field);
          }}
        >
          <SwapVertIcon sx={{ width: "16px" }} />
        </IconButton>
      </div>
    </>
  );
};
export default HeaderColumn;
